import jQuery from 'jquery';
import * as SegmentIO from 'rp-analytics';

const PAGE_TRAITS = {
    [SegmentIO.TRAIT_RACE_ID]: jQuery('[data-card-race-id]').attr('data-card-race-id'),
    [SegmentIO.TRAIT_RACE_DATE]: jQuery('[data-card-race-date]').attr('data-card-race-date'),
    [SegmentIO.TRAIT_RACE_TIME]: jQuery('[data-card-race-time]').attr('data-card-race-time'),
    [SegmentIO.TRAIT_RACECOURSE]: jQuery('[data-card-coursename]').attr('data-card-coursename'),
};

const OFFER_WIDTH = 258;
const OFFERS_PANEL_CLASS = 'RC-raceOffersPanel';
const OFFERS_CHEVRON_CLASS = 'RC-raceOffersPanel__chevron';
const OFFERS_HEADER_SELECTOR = '.RC-raceOffersPanel__header';
const OFFERS_LIST_SELECTOR = '.RC-raceOffers__list';
const OFFER_SELECTOR = '.RC-raceOffer__item';
const OFFER_TITLE_SELECTOR = '.RC-raceOffer__title';
const OFFERS_WRAPPER_SELECTOR = '.RC-raceOffers__wrapper';
const OFFERS_CLAIM_BTN_SELECTOR = '.RC-raceOffer__claim-btn';
const PANEL_STATES = {
    closed: '--closed',
    disabled: '--disabled',
    show: '--show',
    hide: '--hide'
};

export default class RaceOffers {
    init($panel) {
        this.windowWidth = jQuery(window).width();
        this.$panel = $panel;
        this.$header = jQuery(OFFERS_HEADER_SELECTOR);

        this.$list = jQuery(OFFERS_LIST_SELECTOR);
        this.$wrapper = jQuery(OFFERS_WRAPPER_SELECTOR);
        this.$offers = jQuery(OFFER_SELECTOR);
        this.$leftChevron = jQuery(`.${OFFERS_CHEVRON_CLASS}--left`);
        this.$rightChevron = jQuery(`.${OFFERS_CHEVRON_CLASS}--right`);

        this.$wrapper.css('width', `${OFFER_WIDTH * this.$offers.length - 8}px`);

        this.bindEvents();
    }

    openPanel() {
        this.$panel.removeClass(OFFERS_PANEL_CLASS + PANEL_STATES.closed);
        SegmentIO.trackRacecardOfferAccordionOpened(PAGE_TRAITS);
    }

    closePanel() {
        this.$panel.addClass(OFFERS_PANEL_CLASS + PANEL_STATES.closed);
        SegmentIO.trackRacecardOfferAccordionClosed(PAGE_TRAITS);
    }

    moveCarouselLeft() {
        const wrapperWidth = this.$wrapper.children().length * OFFER_WIDTH;
        const maxLeftOffset = wrapperWidth - this.$list.width() - 8;
        const maxOffers = Math.floor(this.$list.width() / OFFER_WIDTH);
        const initialOffset = (this.$list.width() - maxOffers * OFFER_WIDTH + 8) / 2 - OFFER_WIDTH;
        const leftOffset = Number(this.$wrapper.css('left').split('px')[0]);

        if (leftOffset === 0 && -initialOffset < maxLeftOffset) {
            this.$wrapper.css('left', `${initialOffset}px`);
            return;
        }

        if (maxLeftOffset <= OFFER_WIDTH - leftOffset) {
            this.$wrapper.css('left', `-${maxLeftOffset}px`);
            return;
        }

        this.$wrapper.css('left', `${leftOffset - OFFER_WIDTH}px`);
    }

    moveCarouselRight() {
        const wrapperWidth = this.$wrapper.children().length * OFFER_WIDTH;
        const maxLeftOffset = wrapperWidth - this.$list.width() - 8;
        const leftOffset = Number(this.$wrapper.css('left').split('px')[0]);
        const maxOffers = Math.floor(this.$list.width() / OFFER_WIDTH);
        const initialOffset = OFFER_WIDTH - (this.$list.width() - maxOffers * OFFER_WIDTH + 8) / 2;

        if (maxLeftOffset === -leftOffset && initialOffset - maxLeftOffset < 0) {
            this.$wrapper.css('left', `${initialOffset - maxLeftOffset}px`);
            return;
        }

        if (-(leftOffset + OFFER_WIDTH) <= 0) {
            this.$wrapper.css('left', '0px');
            return;
        }

        this.$wrapper.css('left', `${leftOffset + OFFER_WIDTH}px`);
    }

    setChevronsDisabledClass() {
        const wrapperWidth = this.$wrapper.children().length * OFFER_WIDTH;
        const maxLeftOffset = wrapperWidth - this.$list.width() - 8;
        const leftOffset = Number(this.$wrapper.css('left').split('px')[0]);

        if (leftOffset === 0 && -leftOffset < maxLeftOffset) {
            if (!this.$leftChevron.hasClass(`${OFFERS_CHEVRON_CLASS}${PANEL_STATES.disabled}`)) {
                this.$leftChevron.addClass(`${OFFERS_CHEVRON_CLASS}${PANEL_STATES.disabled}`);
            }
        } else {
            this.$leftChevron.removeClass(`${OFFERS_CHEVRON_CLASS}${PANEL_STATES.disabled}`);
        }

        if (-leftOffset >= maxLeftOffset && leftOffset !== 0) {
            if (!this.$rightChevron.hasClass(`${OFFERS_CHEVRON_CLASS}${PANEL_STATES.disabled}`)) {
                this.$rightChevron.addClass(`${OFFERS_CHEVRON_CLASS}${PANEL_STATES.disabled}`);
            }
        } else {
            this.$rightChevron.removeClass(`${OFFERS_CHEVRON_CLASS}${PANEL_STATES.disabled}`);
        }
    }

    bindEvents() {
        this.$header.click(() => {
            if (this.$panel.hasClass(OFFERS_PANEL_CLASS + PANEL_STATES.closed)) {
                this.openPanel();
                return;
            }

            this.closePanel();
        });

        if (this.$leftChevron.length > 0 && this.$rightChevron.length > 0) {
            this.$leftChevron.click(() => {
                this.moveCarouselRight();
                this.setChevronsDisabledClass();
            });

            this.$rightChevron.click(() => {
                this.moveCarouselLeft();
                this.setChevronsDisabledClass();
            });

            jQuery(window).resize(() => {
                const currentWidth = jQuery(window).width();
                if (currentWidth !== this.windowWidth) {
                    this.windowWidth = currentWidth;
                    this.$wrapper.css('left', '0px');
                    this.$leftChevron.addClass(`${OFFERS_CHEVRON_CLASS}${PANEL_STATES.disabled}`);
                    this.$rightChevron.removeClass(`${OFFERS_CHEVRON_CLASS}${PANEL_STATES.disabled}`);
                }
            });
        }

        jQuery(document).ready(() => {
            jQuery('.scrollbar-inner').scrollbar();
        });

        jQuery(OFFERS_CLAIM_BTN_SELECTOR).click((e) => {
            const $offerElement = jQuery(e.target).closest(OFFER_SELECTOR);
            const bookmakerName = $offerElement.attr('data-bookmaker-name');
            const offerName = $offerElement.find(OFFER_TITLE_SELECTOR).text();

            SegmentIO.trackRacecardOfferButtonClicked({
                ...PAGE_TRAITS,
                [SegmentIO.TRAIT_BOOKMAKER]: bookmakerName,
                [SegmentIO.TRAIT_BOOKMAKER_OFFER]: offerName,
            });
        });
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/raceOffers.js